/**
 * Obtiene la variante del badge según el estado del cliente
 * @param {number} idEstatus - ID del estado del cliente (1: activo, 2: inactivo, 3: pendiente)
 * @returns {string} Variante del badge ('success', 'warning', 'error', 'neutral')
 */
export const getStatusVariant = (idEstatus) => {
  switch (idEstatus) {
    case 1:
      return 'success';
    case 2:
      return 'error';
    case 3:
      return 'warning';
    default:
      return 'neutral';
  }
};

/**
 * Formatea el nombre completo del cliente con su ID
 * @param {object} client - Objeto del cliente
 * @returns {string} Nombre formateado con ID
 */
export const formatClientName = (client) => {
  if (!client) return '';
  const prefix = client?.IdTipoCliente === 1 ? 'B' : '';
  const nombre = client?.Nombre || '';
  const apellidos = client?.Apellidos || '';
  const idCliente = client?.IdCliente || '';
  return `${nombre} ${apellidos} (${prefix}${idCliente})`.trim();
};

/**
 * Formatea el código del cliente
 * @param {object} client - Objeto del cliente
 * @returns {string} Código formateado
 */
export const formatClientCode = (client) => {
  if (!client) return 'N/A';
  const prefix = client?.IdTipoCliente === 1 ? 'B' : '';
  return `${prefix}${client?.IdCliente || ''}`;
};

